<template>
  <rx-role :roles="roles">
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <v-text-field v-model="innerValue" :dense="dense" :label="label" v-bind="$attrs" v-on="$listeners" :error-messages="errors" autocomplete="off">
      <template #append>
        <slot name="append" />
      </template>
      <template #append-outer>
        <slot name="append-outer" />
      </template>
      <template #default>
        <slot name="default" />
      </template>
      <template #label>
        <slot name="label" />
      </template>
      <template #message>
        <slot name="message" />
      </template>
      <template #prepend>
        <slot name="prepend" />
      </template>
      <template #prepend-inner>
        <slot name="prepend-inner" />
      </template>
       <template #progress>
        <slot name="progress" />
      </template>
    </v-text-field>
  </ValidationProvider>
  </rx-role>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import RxRole from "@/redworks/components/base/RxRole";
export default {
  components: {
    ValidationProvider,
    RxRole
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: [Number, String],
    },
    roles: {
      type: Array,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue : '',
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  mounted() {
    if (this.value != null) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style>
</style>